import React from 'react';
import './staticAdd.css'; // Optional for custom styling

const StaticAdd = () => {
  return (
    <div>
      <div className="container">

        {/* Section 1 */}
        <div className="row align-items-center mb-5 flex-column-reverse flex-md-row">
          <div className="col-md-6 mt-4 mt-md-0">
            <h3>Start your website with Panorama today!</h3>
            <p id='staticAddTextCol1'>We understand that even the best technology is only as good as the people behind it. That’s why we offer expert, 24/7 support!</p>
          </div>
          <div className="col-md-6 text-center">
            <img
              src="assets/images/homeImg1.svg"
              alt="Start website"
              className="img-fluid"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        </div>

        {/* Section 2 */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6 text-center">
            <img
              src="assets/images/homeImg2.svg"
              alt="Get started"
              className="img-fluid"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
          <div className="col-md-6 mt-4 mt-md-0">
            <h3>Get started quickly, easily and at a minimal price!</h3>
            <p id='staticAddTextCol2'>You can choose from our wide selection of pre-designed themes, or you can create your own extraordinary website and get it up and running instantly!</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default StaticAdd;
